export default "__VITE_ASSET__D834_lZN__"